<template>
    <div id="answer">
        <div class="app-container mb-5" v-if="!$global.loading">

            <div class="d-flex justify-content-between align-items-center mb-5">
                <div class="page-title">
                    <router-link to="/campaigns">
                            <span class="breadcrumb-link">
                                <v-icon class="breadcrumb-link-icon">dashboard</v-icon> Mes campagnes
                            </span>
                    </router-link>
                    <v-icon>keyboard_arrow_right</v-icon>
                    <router-link :to="'/campaign/cadh/' + getB64(campaign.id)">{{ campaign.name }}</router-link>
                    <v-icon>keyboard_arrow_right</v-icon>
                    <router-link :to="'/summary/' + getB64(provider.id)" v-if="provider !== null">
                        {{ provider.last_version.name }}
                    </router-link>
                    <h4 v-else-if="entity !== null" class="ml-2 my-auto">{{ entity.name }}</h4>
                </div>

                <div class="d-flex" v-if="provider !== null">
                    <div class="mt-auto mb-auto" v-if="provider.apidae_source !== null">
                        {{ provider.apidae_source.external_id }}
                    </div>
                    <div class="mt-auto mb-auto" v-else-if="provider.tourinsoft_source !== null">
                        {{ provider.tourinsoft_source.external_id }}
                    </div>
                    <div v-if="provider.apidae_source !== null">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon target="_blank" :href="provider.apidae_source.url">
                                    <v-icon>open_in_new</v-icon>
                                </v-btn>
                            </template>
                            <span>Voir sur Apidae</span>
                        </v-tooltip>
                    </div>
                </div>

                <div class="d-flex" v-else-if="entity !== null">
                    <div class="mt-auto mb-auto" v-if="entity.external_id !== null">
                        {{ entity.external_id }}
                    </div>
                    <div v-if="entity.external_id !== null">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon target="_blank" :href=
                                  "'https://base.apidae-tourisme.com/gerer/objet-touristique/'+ entity.external_id +'/consulter/'">
                                    <v-icon>open_in_new</v-icon>
                                </v-btn>
                            </template>
                            <span>Voir sur Apidae</span>
                        </v-tooltip>
                    </div>
                </div>
            </div>

            <div class="container-fluid">
                <div class="row">
                    <v-card class="p-4 mb-5 mr-4 col">
                        <h4 class="mb-5">Réponse du prestataire</h4>

                        <div>
                            <p><b>Suivi de l'adhésion</b></p>
                            <p>
                                Réponse de <b>{{ answer.first_name }} {{ answer.last_name }} (<a
                              :href="'mailto:' + answer.email + '?subject=Au sujet de ' + getName()">{{
                                    answer.email
                                }}</a>)</b>
                                <br>
                                <b>Reçue le {{ formatDate(answer.created_at) }}</b>
                                <a class="ml-2" :href="apiUrl + '/export-to-pdf/cadh/' + answer.id">
                                    <span>- Télécharger le bulletin d'adhésion</span></a>
                                <br>
                                Statut d'adhésion : <b>{{ answer.form.state.label }}</b>
                                <v-icon color="primary" small @click="openAnswerStateModale = true" class="pl-2">edit
                                </v-icon>
                            </p>

                            <div>
                                <p><b>Informations administratives</b></p>
                                <table class="w-100">
                                    <tr v-if="answer.entity_name">
                                        <td style="white-space: pre" width="180px">
                                            Nom de l'entité
                                        </td>
                                        <td>
                                            <b>{{ answer.entity_name }}</b>
                                        </td>
                                    </tr>
                                    <tr v-if="answer.phone">
                                        <td style="white-space: pre" width="180px">
                                            Téléphone
                                        </td>
                                        <td>
                                            <b>{{ answer.phone }}</b>
                                        </td>
                                    </tr>
                                    <tr v-if="answer.birthday">
                                        <td style="white-space: pre" width="180px">
                                            Date de naissance
                                        </td>
                                        <td>
                                            <b>{{ answer.birthday }}</b>
                                        </td>
                                    </tr>
                                    <tr v-if="answer.address || answer.postal_code || answer.city || answer.country">
                                        <td style="white-space: pre" class="pr-5" width="180px">
                                            Adresse
                                        </td>
                                        <td>
                                            <b>
                                                {{ answer.address }} {{ answer.postal_code }} {{ answer.city }}
                                                {{ answer.country }}
                                            </b>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div v-if="hasAdminData" class="border-top mt-3">
                            <table class="mt-2 w-100">
                                <tr v-if="answer.siret">
                                    <td style="white-space: pre" width="180px">
                                        Siret
                                    </td>
                                    <td>
                                        <b>{{ answer.siret }}</b>
                                    </td>
                                </tr>
                                <tr v-if="answer.siren">
                                    <td style="white-space: pre" width="180px">
                                        Siren
                                    </td>
                                    <td>
                                        <b>{{ answer.siren }}</b>
                                    </td>
                                </tr>
                                <tr v-if="answer.intra_vat">
                                    <td style="white-space: pre" width="180px">
                                        TVA intracommunautaire
                                    </td>
                                    <td>
                                        <b>{{ answer.intra_vat }}</b>
                                    </td>
                                </tr>
                                <tr v-if="answer.immat">
                                    <td style="white-space: pre" width="180px">
                                        Immat Atout France
                                    </td>
                                    <td>
                                        <b>{{ answer.immat }}</b>
                                    </td>
                                </tr>
                                <tr v-if="answer.rcs">
                                    <td style="white-space: pre" width="180px">
                                        RCS
                                    </td>
                                    <td>
                                        <b>{{ answer.rcs }}</b>
                                    </td>
                                </tr>
                                <tr v-if="answer.ape_naf">
                                    <td style="white-space: pre" width="180px">
                                        APE/NAF
                                    </td>
                                    <td>
                                        <b>{{ answer.ape_naf }}</b>
                                    </td>
                                </tr>
                            </table>

                            <div class="mt-5 pt-5 d-flex justify-content-between"
                                 v-if="hasAdminData">
                                <v-btn outlined class="custom-button-primary mr-2"
                                       @click="writeApidaeAdminData('OBJ')"
                                       :disabled="provider === null || provider.apidae_source === null">
                                    <v-icon left>upload</v-icon>
                                    Mettre à jour l'objet
                                </v-btn>
                                <v-btn outlined class="custom-button-primary mr-2"
                                       @click="writeApidaeAdminData('ENT')">
                                    <v-icon left>upload</v-icon>
                                    Mettre à jour l'entité
                                </v-btn>
                            </div>
                        </div>
                    </v-card>

                    <v-card class="p-4 mb-5 col">
                        <div class="container p-0">
                            <div class="row justify-content-between">
                                <h4 class="mb-4 col-9">Informations de paiement</h4>
                                <div v-if="answer.transaction_id && answer.transaction_id.includes('pi')"
                                     class="col-3 text-end">
                                    Voir sur Stripe
                                    <a :href="stripeBaseUrl + answer.transaction_id" target="_blank">
                                        <v-icon color="primary" class="mr-3">open_in_new</v-icon>
                                    </a>
                                </div>
                            </div>
                            <table>
                                <tr class="pb-2">
                                    <td style="white-space: pre" class="pr-5">
                                        Montant facturé
                                    </td>
                                    <td><b>{{ formatPrice(answer.amount / 100) }}&nbsp;€</b></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="white-space: pre" class="pr-5">
                                        Mode de paiement
                                    </td>
                                    <td
                                      v-if="answer.payment_option === null && answer.payment_state.code === 'NO_PAIEMENT'">
                                        <b>Aucun</b>
                                    </td>
                                    <td v-else-if="answer.payment_option !== null">
                                        <b>{{ answer.payment_option.label }}</b>
                                    </td>
                                    <td class="pl-5">
                                        <v-icon color="primary" small @click="prepareOpenPaymentModale">edit
                                        </v-icon>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="white-space: pre" class="pr-5">
                                        Remboursement
                                    </td>
                                    <td><b>{{ answer.refund ? formatPrice(answer.refund / 100) + "&nbsp;€" : "Aucun" }}</b>
                                    </td>
                                    <td class="pl-5">
                                        <v-icon color="primary" small @click="prepareOpenRefundModale">edit
                                        </v-icon>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="white-space: pre" class="pr-5">
                                        Paiement
                                    </td>
                                    <td :style="'color:' + getCodeColor(answer.payment_state.code)">
                                        <b>{{ answer.payment_state.label }}</b>
                                    </td>
                                    <td class="pl-5">
                                        <v-tooltip right v-if="answer.payment_state.label === 'En cours'">
                                            <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-icon color="primary" small @click="validatePaiement">done</v-icon>
                            </span>
                                            </template>
                                            <span>Valider le paiement</span>
                                        </v-tooltip>
                                        <v-tooltip right v-else-if="answer.payment_state.label === 'Payé'">
                                            <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-icon color="red" small @click="cancelPaiement">clear</v-icon>
                            </span>
                                            </template>
                                            <span>Annuler le paiement</span>
                                        </v-tooltip>
                                    </td>
                                </tr>
                                <tr v-if="answer.payment_state.label === 'Payé'">
                                    <td style="white-space: pre" class="pr-5">
                                        Date de paiement
                                    </td>
                                    <td><b>{{ formatDate(answer.paid_at, false) }}</b></td>
                                    <td class="pl-5">
                                        <v-icon color="primary" small @click="showPaidAtPicker = true">edit
                                        </v-icon>
                                    </td>
                                </tr>
                                <tr v-if="answer.transaction_id && !answer.transaction_id.includes('pi')">
                                    <td style="white-space: pre" class="pr-5">
                                        Identifiant de transaction
                                    </td>
                                    <td><b>{{ answer.transaction_id }}</b></td>
                                </tr>
                            </table>
                        </div>

                        <div class="container p-0">
                            <div class="align-baseline d-flex">
                                <h4 class="mt-5 mb-4">Facturation</h4>
                            </div>
                            <table>
                                <tr v-if="isInvoiceAvailable && account.cadh_account_invoice">
                                    <td style="white-space: pre" class="pr-5">
                                        Date de facture
                                    </td>
                                    <td><b>
                                        {{ answer.cadh_answer_invoice && answer.cadh_answer_invoice.invoice_date ?
                                      formatDate(answer.cadh_answer_invoice.invoice_date, false) : "Générée automatiquement"
                                        }}
                                    </b>
                                    </td>
                                    <td class="pl-5">
                                        <v-icon color="primary" small @click="showInvoiceDatePicker = true">edit
                                        </v-icon>
                                    </td>
                                </tr>
                                <tr v-if="isInvoiceAvailable && account.cadh_account_invoice">
                                    <td style="white-space: pre" class="pr-5">
                                        Date d'échéance
                                    </td>
                                    <td>
                                        <b>
                                            {{ answer.cadh_answer_invoice && answer.cadh_answer_invoice.paiement_deadline_date ?
                                          formatDate(answer.cadh_answer_invoice.paiement_deadline_date, false) : "Générée automatiquement"
                                            }}
                                        </b>
                                    </td>
                                    <td class="pl-5">
                                        <v-icon color="primary" small @click="showDeadLineDatePicker = true">edit
                                        </v-icon>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="white-space: pre" class="pr-5">
                                        Numéro de facture
                                    </td>
                                    <td v-if="isInvoiceAvailable && account.cadh_account_invoice">
                                        <b>{{ answer.bill_number ? answer.bill_number : "Généré automatiquement" }}</b>
                                    </td>
                                    <td v-else>
                                        <b>{{ answer.bill_number ? answer.bill_number : "Non définie" }}</b>
                                    </td>
                                    <td class="pl-5" v-if="!isInvoiceAvailable">
                                        <v-icon color="primary" small @click="showBillNumberModale = true">edit
                                        </v-icon>
                                    </td>
                                </tr>
                                <tr v-if="isInvoiceAvailable && account.cadh_account_invoice">
                                    <td style="white-space: pre" class="pr-5">
                                        Acquittée
                                    </td>
                                    <td>
                                        <v-checkbox
                                          style="padding: 0 !important; margin: 0 !important; zoom: 0.6 !important"
                                          :input-value="acquitted" @change="updateAcquitted" hide-details>
                                        </v-checkbox>
                                    </td>
                                </tr>
                            </table>

                            <div class="d-flex justify-content-around">

                                <div class="mt-5 pt-5 text-center"
                                     v-if="isInvoiceAvailable && !account.cadh_account_invoice">
                                    <v-btn class="default-button" @click="needConfigModal = true">
                                        <v-icon class="mr-2">file_download</v-icon>
                                        Obtenir la facture
                                    </v-btn>
                                </div>

                                <div class="mt-5 pt-5 text-center" v-else-if="isInvoiceAvailable &&
                            (!invoiceIsUpToDate || !noConfigChange) && account.cadh_account_invoice">
                                    <v-btn class="default-button" @click="generateInvoicePdf">
                                        <v-icon class="mr-2">file_download</v-icon>
                                        Obtenir la facture
                                    </v-btn>
                                </div>

                                <div class="mt-5 pt-5 text-center"
                                     v-if="answer.cadh_answer_invoice && answer.cadh_answer_invoice.last_pdf &&
                   isInvoiceAvailable && invoiceIsUpToDate && noConfigChange && account.cadh_account_invoice">
                                    <v-btn class="default-button" @click="openInvoicePdf">
                                        <v-icon class="mr-2">file_download</v-icon>
                                        Obtenir la facture
                                    </v-btn>
                                </div>

                                <div class="pt-5 text-center"
                                     :class="{'mt-5': answer.cadh_answer_invoice && !answer.cadh_answer_invoice.sent_at}">
                                    <div v-if="answer.cadh_answer_invoice && answer.cadh_answer_invoice.sent_at"
                                         class="last-write">
                                        Dernier envoi le {{ formatDate(answer.cadh_answer_invoice.sent_at) }}
                                    </div>
                                    <v-tooltip slot="append-outer" bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn class="default-button" @click="prepareSend"
                                                   v-on="on" v-if="hasPdfToSend">
                                                <v-icon class="mr-2">send</v-icon>
                                                Envoyer la facture
                                            </v-btn>
                                        </template>
                                        <span>
                                            Si une modification de la facture a eu lieu, la facture sera regénérée et
                                            téléchargée avant l'envoi.
                                        </span>
                                    </v-tooltip>
                                </div>

                            </div>
                        </div>
                    </v-card>
                </div>
            </div>

            <div class="pl-0 pr-0 mt-3" id="cadh-answer-infos">
                <div class="mb-5">
                    <div class="d-flex justify-content-between gap-20 mb-3" v-if="answer.extra !== null">
                        <v-card class="elevation-0" id="cadh-more-info">
                            <v-card-title>Informations supplémentaires</v-card-title>
                            <v-card-text>
                                {{ answer.extra ? answer.extra : "Non communiqué" }}
                            </v-card-text>
                        </v-card>
                    </div>

                    <v-card class="elevation-0 mb-3" v-if="answer.offers.length">
                        <v-card-title>Offres sélectionnées</v-card-title>

                        <v-card-text>
                            <v-simple-table>
                                <thead>
                                <th>Nom</th>
                                <th>Prix unitaire</th>
                                <th>Quantité</th>
                                <th>Prix</th>
                                </thead>

                                <tbody>
                                <tr v-for="offer in answer.offers">
                                    <td>
                                        <div>
                                                    <span style="font-size: 13px; font-weight: bold">{{
                                                            offer.offer.label
                                                        }}</span>
                                            <span style="color: red" v-if="offer.offer.inclused"> -
                                                        inclus</span>
                                        </div>
                                        <div v-for="param of offer.params">
                                            <span>{{ param.value.cadh_offer_param.label }} : </span>
                                            <span v-if="!isQuantifiableParam(param)">{{ param.value.label }}</span>
                                            <span v-if="isQuantifiableParam(param)">
                                                        {{ param.quantity }}
                                                    </span>
                                        </div>
                                    </td>
                                    <td>{{ formatPrice(getOfferPrice(offer)) }}&nbsp;€ {{ priceType }}</td>
                                    <td>{{ offer.quantity }}</td>
                                    <td>{{ formatPrice(getTotalOfferPrice(offer)) }}&nbsp;€ {{ priceType }}</td>
                                </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0 mb-3" v-if="answer.options.length">
                        <v-card-title>Options sélectionnées</v-card-title>

                        <v-card-text>
                            <v-simple-table>
                                <thead>
                                <th>Nom</th>
                                <th>Prix unitaire</th>
                                <th>Quantité</th>
                                <th>Prix</th>
                                </thead>

                                <tr v-for="option in answer.options">
                                    <td>
                   <span style="font-size: 13px; font-weight: bold" v-if="option.label">
                    {{ option.label }}
                   </span>

                                        <span style="font-size: 13px; font-weight: bold"
                                              v-else-if="option.level && option.level.parent">
                    {{ option.level.parent.name }} - {{ option.level.name }} - {{ option.name }}
                   </span>

                                        <span style="font-size: 13px; font-weight: bold" v-else-if="option.level">
                    {{ option.level.name }} - {{ option.name }}
                   </span>

                                        <span style="font-size: 13px; font-weight: bold" v-else>
                    {{ option.name }}
                   </span>

                                        <span style="color: red" v-if="!option.immediate"> - facturé
                                                ultérieurement</span>
                                    </td>
                                    <td>{{ formatPrice(option.price / 100) }}&nbsp;€ {{ priceType }}</td>
                                    <td>{{ option.pivot.quantity }}</td>
                                    <td>{{ formatPrice(option.price * option.pivot.quantity / 100) }}&nbsp;€
                                        {{ priceType }}
                                    </td>
                                </tr>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0 mb-3" v-if="answer.discounts.length">
                        <v-card-title>Remises</v-card-title>

                        <v-card-text>
                            <v-simple-table>
                                <thead>
                                <th>Nom</th>
                                <th>Remise</th>
                                </thead>

                                <tbody>
                                <tr v-for="discount in answer.discounts">
                                    <td>
                                        <div>
                                                <span style="font-size: 13px; font-weight: bold">
                                                    {{ discount.label }}
                                                </span>
                                        </div>
                                    </td>
                                    <td>{{ getDiscountPrice(discount) }}&nbsp;€ {{ priceType }}</td>
                                </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0" v-if="answer.informations.length">
                        <v-card-title>Informations sélectionnées</v-card-title>

                        <v-card-text>
                            <v-simple-table>
                                <tbody>
                                <tr v-for="information in answer.informations">
                                    <td>
                <span style="font-size: 13px">
                {{ information.name }}
                </span>
                                    </td>
                                </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </div>

                <hr v-if="criterias.length">

                <v-card v-if="criterias.length" class="elevation-0">
                    <v-card-title class="d-flex">Critères internes
                        <v-tooltip slot="append-outer" bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon class="align-baseline">
                                    <v-icon>help</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                Assurez vous d’avoir au préalable ajouté Dahub<br>
               en tant que Membre collaborateur de vos critères internes sur Apidae.
                            </span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text>
                        <v-autocomplete :items="criterias" chips deletable-chips style="background-color: white"
                                        label="Sélectionner vos critères internes" item-text="libelle" item-value="id"
                                        hide-details
                                        v-model="selectedCriterias" multiple outlined>
                        </v-autocomplete>

                        <div class="d-flex justify-content-end">
                            <v-btn class="mt-5 default-button" @click="writeCriterias">Ajouter les critères sur
                                Apidae
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </div>

        <v-dialog v-model="openRefundModale" width="700px">
            <v-card v-if="answer !== null">
                <v-card-title>
                    <h3 class="mb-4">Modifier le remboursement</h3>
                </v-card-title>

                <v-card-text>
                    <v-text-field outlined type="text" label="Montant (en €)" v-model="refund">
                    </v-text-field>
                </v-card-text>

                <v-card-actions class="w-100 px-6 d-flex justify-content-between">
                    <v-btn color="error" @click="openRefundModale = false">
                        Annuler
                    </v-btn>

                    <v-btn color="primary" @click="modifyRefund">
                        Enregistrer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showBillNumberModale" width="700px">
            <v-card v-if="showBillNumberModale">
                <v-card-title>
                    <h3 class="mb-4">Modifier le numéro de facture</h3>
                </v-card-title>

                <v-card-text>
                    <v-text-field outlined type="text" label="Numéro de facture"
                                  v-model="answer.bill_number">
                    </v-text-field>
                </v-card-text>

                <v-card-actions class="w-100 d-flex justify-content-between">
                    <v-btn color="error" @click="showBillNumberModale = false">
                        Annuler
                    </v-btn>

                    <v-btn color="primary" @click="modifyBillNumber">
                        Enregistrer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="openPaymentModale" width="700px">
            <v-card v-if="answer !== null">
                <v-card-title>
                    <h3 class="mb-4">Modifier le mode de paiement</h3>
                </v-card-title>

                <v-card-text>
                    <v-select label="Mode de paiement" :items="paymentOptions" outlined return-object item-text="label"
                              v-model="paymentOption">
                    </v-select>
                </v-card-text>

                <v-card-actions class="w-100 px-6 d-flex justify-content-between">
                    <v-btn color="error" @click="openPaymentModale = false">
                        Annuler
                    </v-btn>

                    <v-btn color="primary" @click="modifyPaymentOption">
                        Enregistrer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="openAnswerStateModale" width="700px">
            <v-card v-if="answer !== null">
                <v-card-title>
                    <h3 class="mb-4">Modifier le statut d'adhésion</h3>
                </v-card-title>

                <v-card-text>
                    <v-select label="Statut adhésion" outlined v-model="selectedState"
                              :items="status" item-text="label" item-value="name" class="mt-6">
                    </v-select>
                </v-card-text>

                <v-card-actions class="w-100 px-6 d-flex justify-content-between">
                    <v-btn color="error" @click="openAnswerStateModale = false">
                        Annuler
                    </v-btn>

                    <v-btn color="primary" @click="updateSelectedState">
                        Enregistrer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog ref="dialog" v-model="showPaidAtPicker" width="290px">
            <v-card v-if="answer !== null">
                <v-date-picker locale="fr-FR" color="primary" v-model="paidAtDate"
                               :first-day-of-week="1" class="d-flex justify-content-center">
                </v-date-picker>

                <v-spacer></v-spacer>
                <v-card-actions class="w-100 px-6 d-flex justify-content-between">
                    <v-btn text color="primary" @click="showPaidAtPicker = false">
                        Annuler
                    </v-btn>

                    <v-btn text color="primary" @click="setPaidAtDatePicker(paidAtDate)">
                        Enregistrer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog ref="dialog" v-model="showInvoiceDatePicker" width="290px">
            <v-card v-if="answer !== null">
                <v-date-picker locale="fr-FR" color="primary" v-model="invoiceDate" :first-day-of-week="1">
                </v-date-picker>

                <v-spacer></v-spacer>
                <v-card-actions class="w-100 px-6 d-flex justify-content-between">
                    <v-btn text color="primary" @click="showInvoiceDatePicker = false">
                        Annuler
                    </v-btn>

                    <v-btn text color="primary" @click="setInvoiceDatePicker(invoiceDate)">
                        Enregistrer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog ref="dialog" v-model="showDeadLineDatePicker" width="290px">
            <v-card v-if="answer !== null">
                <v-date-picker locale="fr-FR" color="primary" v-model="deadLineDate" :first-day-of-week="1">
                </v-date-picker>
                <v-spacer></v-spacer>

                <v-card-actions class="w-100 px-6 d-flex justify-content-between">
                    <v-btn text color="primary" @click="showDeadLineDatePicker = false">
                        Annuler
                    </v-btn>

                    <v-btn text color="primary" @click="setDeadLineDatePicker(deadLineDate)">
                        Enregistrer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog ref="dialog" v-model="needConfigModal" width="400px">
            <v-card>
                <v-card-title>
                    <h3 class="mb-4">Configuration nécessaire</h3>
                </v-card-title>

                <v-card-text>
                    Avant de pouvoir générer une facture, vous devez configurer votre outil de génération de factures.
                </v-card-text>

                <v-card-actions class="w-100 px-6 d-flex justify-content-between">
                    <v-btn color="error" @click="needConfigModal = false">
                        Annuler
                    </v-btn>

                    <router-link to="/configuration/invoice-config">
                        <v-btn color="primary" @click="needConfigModal = false">
                            Configurer
                        </v-btn>
                    </router-link>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog ref="dialog" v-model="emailModal" width="900px">
            <InvoiceMailModal
              :answerId="answerId"
              :campaign="campaign"
              :acquitted="acquitted"
            ></InvoiceMailModal>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import Confirm from "../../tools/Confirm"
import { mapState } from "vuex"
import _ from "lodash"
import InvoiceMailModal from "./InvoiceMailModal.vue"
import { ca } from "@mapbox/mapbox-gl-geocoder/lib/exceptions"

export default {
    name: "AdhesionAnswer",
    components: { Confirm, InvoiceMailModal },
    data() {
        return {
            answerId: null,
            answer: null,
            campaign: null,
            provider: null,
            entity: null,
            criterias: [],
            selectedCriterias: [],
            cadhFrontUrl: process.env.VUE_APP_CADH_URL,
            openPaymentModale: false,
            openRefundModale: false,
            showPaidAtPicker: false,
            showInvoiceDatePicker: false,
            showDeadLineDatePicker: false,
            billNumber: null,
            refund: null,
            paymentOption: null,
            paymentOptions: [],
            apiUrl: process.env.VUE_APP_API_URL,
            status: [
                {
                    name: "ANSWERED",
                    label: "Réponse reçue",
                },
                {
                    name: "VALIDATED",
                    label: "Validé",
                },
                {
                    name: "REFUSED",
                    label: "Refusé",
                },
                {
                    name: "REFUNDED",
                    label: "Remboursé",
                },
            ],
            selectedState: "",
            paidAtDate: null,
            selectedDate: null,
            invoiceDate: null,
            deadLineDate: null,
            acquitted: false,
            priceType: "",
            showBillNumberModale: false,
            needConfigModal: false,
            stripeBaseUrl: "https://dashboard.stripe.com/",
            hasStripe: null,
            openAnswerStateModale: false,
            invoiceIsUpToDate: true,
            noConfigChange: true,
            hasPdfToSend: false,
            emailModal: false,
        }
    },
    methods: {
        getAnswer: _.debounce(function() {
            this.$global.loading = true

            this.$http.get("adhesion/answer/" + this.answerId).then(res => {
                this.answer = res.body.data.answer
                this.campaign = res.body.data.answer.form.batch.cadh
                this.provider = res.body.data.answer.form.provider
                this.entity = res.body.data.answer.form.entity
                this.priceType = res.body.data.priceType

                this.selectedCriterias = this.campaign.apidae_criterias.map(criteria => criteria.external_id)

                this.getPaymentOptions()

                this.setSelectedState()

                this.setAcquitted()

                this.setDates()

                this.setHasPdfToSend()


                this.noConfigChange = this.answer.cadh_answer_invoice && this.account.cadh_account_invoice &&
                  new Date(this.answer.cadh_answer_invoice.last_generation_date).getTime() >
                  new Date(this.account.cadh_account_invoice.updated_at).getTime()

                this.invoiceIsUpToDate = this.answer.cadh_answer_invoice &&
                  new Date(this.answer.cadh_answer_invoice.last_generation_date).getTime() ===
                  new Date(this.answer.cadh_answer_invoice.updated_at).getTime() &&
                  new Date(this.answer.updated_at).getTime() <
                  new Date(this.answer.cadh_answer_invoice.last_generation_date).getTime()

                this.$global.loading = false
            })
        }, 200),
        getName() {
            return this.provider !== null ? this.provider.name : this.entity.name
        },
        getCodeColor(code) {
            let color = "default"

            if (code === "FAILED") {
                color = "red"
            }

            if (code === "PAID") {
                color = "green"
            }

            if (code === "WAITING") {
                color = "orange"
            }

            return color
        },
        getPaymentOptions() {
            let cadhId = this.answer.form.batch.cadh_id

            this.$http.get("auth/campaigns/cadh/payment-options/" + cadhId).then(res => {
                this.paymentOptions = res.body.data.payment_options
            })
        },
        getInternalCriterias() {
            this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias
            })
        },
        getB64(id) {
            return btoa(id)
        },
        writeCriterias() {
            let sourceId = this.provider !== null ? this.provider.apidae_source.external_id : this.entity.external_id

            let payload = {
                sourceId: sourceId,
                criteria: this.selectedCriterias,
            }

            this.$global.loading = true

            this.$http.post("auth/campaigns/cadh/apidae/write-criteria", payload).then(res => {
                this.$global.loading = false
            })
        },
        prepareOpenPaymentModale() {
            this.openPaymentModale = true
            this.paymentOption = JSON.parse(JSON.stringify(this.answer.payment_option))
        },
        prepareOpenRefundModale() {
            this.openRefundModale = true
            this.refund = JSON.parse(JSON.stringify(this.answer.refund))

            if (this.refund !== null) {
                this.refund /= 100
            }
        },
        validatePaiement() {
            this.$refs.confirm.open("Valider le paiement",
              "Êtes-vous sûr de vouloir valider le paiement ?",
              { color: "red", backgroundTitle: "#4285F4" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    let payload = {
                        answerId: this.answer.id,
                    }

                    this.$http.post("auth/campaigns/cadh/answer/validate-paiement", payload).then(res => {
                        this.$global.loading = false

                        this.getAnswer()
                    })
                }
            })
        },
        cancelPaiement() {
            this.$refs.confirm.open("Annuler le paiement",
              "Êtes-vous sûr de vouloir annuler le paiement ?",
              { color: "red", backgroundTitle: "#4285F4" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    let payload = {
                        answerId: this.answer.id,
                    }

                    this.$http.post("auth/campaigns/cadh/answer/cancel-paiement", payload).then(res => {
                        this.$global.loading = false

                        this.getAnswer()
                    })
                }
            })
        },
        setPaidAtDatePicker(value) {
            let payload = {
                answerId: this.answer.id,
                paidAtDate: value,
            }

            this.$http.post("auth/campaigns/cadh/answer/update-payment-date", payload).then(res => {
                this.getAnswer()
                this.showPaidAtPicker = false
            })
        },
        setInvoiceDatePicker(value) {
            let cadhAnswerInvoiceId = this.answer.cadh_answer_invoice ? this.answer.cadh_answer_invoice.id : null

            let payload = {
                answerInvoiceId: cadhAnswerInvoiceId,
                invoiceDate: value,
                answerId: this.answer.id,
            }

            this.$http.post("auth/invoice/invoice-date", payload).then(res => {
                this.getAnswer()
                this.showInvoiceDatePicker = false
            })
        },
        setDeadLineDatePicker(value) {
            let cadhAnswerInvoiceId = this.answer.cadh_answer_invoice ? this.answer.cadh_answer_invoice.id : null

            let payload = {
                accountId: this.campaign.account_id,
                cadhAnswerInvoiceId: cadhAnswerInvoiceId,
                deadLineDate: value,
                answerId: this.answer.id,
            }

            this.$http.post("auth/invoice/paiement-deadline-date", payload).then(res => {
                this.getAnswer()
                this.showDeadLineDatePicker = false
            })
        },
        openForm() {
            let hash = btoa(this.answerId)
            let url = this.cadhFrontUrl + "/adhesion/update/" + hash

            window.open(url)
        },
        updateAnswerPayment() {
            this.$refs.confirm.open("Valider le paiment",
              "Êtes-vous sûr de vouloir valider le paiement ?",
              { color: "red", backgroundTitle: "#4285F4" }).then((confirm) => {
                if (confirm) {
                    let payload = {
                        answerId: this.answer.id,
                    }

                    this.$http.post("auth/campaigns/cadh/answer/validate-paiement", payload).then(res => {
                        this.getAnswer()
                    })
                }
            })
        },
        modifyRefund() {
            let payload = {
                answerId: this.answer.id,
                refund: this.refund,
            }

            this.$http.post("auth/campaigns/cadh/refund", payload).then(res => {
                this.openRefundModale = false

                this.getAnswer()
            })
        },
        modifyPaymentOption() {
            let payload = {
                answerId: this.answer.id,
                paymentOptionId: this.paymentOption.id,
            }

            this.$http.post("auth/campaigns/cadh/payment-option", payload).then(res => {
                this.openPaymentModale = false

                this.getAnswer()
            })
        },
        getDiscountPrice(discount) {
            return ((discount.value / 100).toPrecision(discount.value.toString().length - 1).toString()
              .replace(".", ","))
        },
        getOfferPrice(offer) {
            let price = offer.offer.price
            let paramsPrice = 0

            if (offer.params.length) {
                if (offer.offer.operation_type == "A") {
                    offer.params.forEach(param => {
                        paramsPrice += this.getParamPrice(param)
                    })
                } else {
                    paramsPrice = 1

                    offer.params.forEach(param => {
                        paramsPrice *= this.getParamPrice(param) / 100
                    })

                    paramsPrice = paramsPrice * 100
                    paramsPrice = Math.round(paramsPrice * 100) / 100
                }
            }

            price += paramsPrice

            if (price > offer.offer.max_price && offer.offer.max_price !== 0) {
                price = offer.offer.max_price
            }

            return price / 100
        },
        getParamPrice(param) {
            let price = 0

            if (param.value !== null) {
                price = param.value.price * param.quantity
            }

            return price
        },
        getTotalOfferPrice(offer) {
            return Math.round(this.getOfferPrice(offer) * offer.quantity * 100) / 100
        },
        isQuantifiableParam(param) {
            let quantifiable = false

            if (param.value !== null && param.value.cadh_offer_param !== null) {
                quantifiable = param.value.cadh_offer_param.field_type === "quantifiable"
            }

            return quantifiable
        },
        updateSelectedState() {
            this.$global.loading = true

            let payload = {
                cadhFormId: this.answer.cadh_form_id,
                state: this.selectedState,
            }

            this.$http.post("auth/campaigns/cadh/answer/update-state", payload).then(res => {
                this.$global.loading = false
                this.openAnswerStateModale = false
                this.getAnswer()
            })
        },
        setSelectedState() {
            this.selectedState = this.answer.form.state.code
        },
        setAcquitted() {
            if (this.answer.cadh_answer_invoice) {
                this.acquitted = this.answer.cadh_answer_invoice.acquitted
            }
        },
        setHasPdfToSend() {
            if (this.answer.cadh_answer_invoice && this.answer.cadh_answer_invoice.last_pdf) {
                this.hasPdfToSend = true
            }
        },
        setDates() {
            this.paidAtDate = this.prepareDate(new Date(this.answer.paid_at))

            if (this.answer.cadh_answer_invoice) {
                this.invoiceDate = this.prepareDate(new Date(this.answer.cadh_answer_invoice.invoice_date))
                this.deadLineDate = this.prepareDate(new Date(this.answer.cadh_answer_invoice.paiement_deadline_date))
            }
        },
        prepareDate(date) {
            return date.getFullYear() + "-" + (("0" + (date.getMonth() + 1)).toString().slice(-2)) + "-" + (("0" + date.getDate()).toString().slice(-2))
        },
        updateAcquitted() {
            let cadhAnswerInvoiceId = this.answer.cadh_answer_invoice ? this.answer.cadh_answer_invoice.id : null

            let payload = {
                cadhAnswerInvoiceId: cadhAnswerInvoiceId,
                answerId: this.answer.id,
            }

            this.$http.post("auth/invoice/cadh-answer-invoice/acquitted", payload).then(res => {
                this.getAnswer()
            })
        },
        modifyBillNumber() {
            let payload = {
                answerId: this.answer.id,
                billNumber: this.answer.bill_number,
            }

            this.$global.loading = true

            this.$http.post("auth/campaigns/cadh/bill-number", payload).then(res => {
                this.$global.loading = false
                this.showBillNumberModale = false

                this.getProviders()
            })
        },
        async openInvoicePdf() {
            this.loadingExport = true

            let res =
              await this.$http.get("auth/invoice/cadh-answer-invoice/" + this.answer.cadh_answer_invoice.id + "/last-pdf")
            let url = res.body.data.url

            this.loadingExport = false

            let a = document.createElement("a")

            a.href = url
            a.target = "_blank"
            a.click()
        },
        generateInvoicePdf() {
            this.$global.loading = true
            this.loadingExport = true

            let url = this.apiUrl + "/generate-invoice/" + this.campaign.account_id + "/" + this.answer.id

            this.loadingExport = false

            let a = document.createElement("a")

            a.href = url
            a.click()
            this.hasPdfToSend = true

            setTimeout(() => {
                this.getAnswer()
            }, 1500)
            this.$global.loading = false
        },
        prepareSend() {
            if (this.answer.cadh_answer_invoice && this.answer.cadh_answer_invoice.last_pdf &&
              this.isInvoiceAvailable && this.invoiceIsUpToDate && this.noConfigChange
              && this.account.cadh_account_invoice) {
                this.emailModal = true
            } else {
                this.generateInvoicePdf()
                this.emailModal = true
            }
        },
        formatPrice(price) {
            return price.toFixed(2).toString().replace(".", ",")
        },
        writeApidaeAdminData(target) {
            let payload = {
                cadhAnswerId: this.answer.id,
                target: target,
            }

            this.$global.loading = true

            this.$http.post("adhesion/answer/write-apidae-admin-data", payload).then(res => {
                this.$global.loading = false
            })
        },
    },
    computed: {
        ca() {
            return ca
        },
        ...mapState("account", ["account", "senders"]),
        isInvoiceAvailable() {
            let available = false
            let contracts = this.account.current_contracts

            if (contracts.length) {

                let module = contracts.find(offer => offer.contract_offer.code === "ADHESION_INVOICE")

                if (module) {
                    available = true
                }

            }
            return available
        },
        hasAdminData() {
            let hasAdminData = false

            if (this.answer) {
                if (this.answer.siret || this.answer.immat || this.answer.rcs || this.answer.ape_naf ||
                  this.answer.siren || this.answer.intra_vat) {
                    hasAdminData = true
                }
            }

            return hasAdminData
        },
    },
    created() {
        this.answerId = atob(this.$route.params.answerId)

        this.getAnswer()
        this.getInternalCriterias()

        this.$global.$on("open-invoice-pdf", () => {
            this.openInvoicePdf()
        })

        this.$global.$on("close-invoice-email-modal", () => {
            this.emailModal = false
        })
    },
}
</script>